<template>
  <div :class="$style['scan-adult-out-stock']" v-loading.fullscreen.lock='loading'>
    <div class="scan-tip">
      <span style="display:inline-block;width:45px;"></span>扫码状态：<i v-if="isCanScan" class="el-icon-success" style="color:#67c243;"></i><i v-else class="isCanScan el-icon-error" style="color:red;"></i>
      <span>{{isCanScan ? '（确保输入法在英文状态下进行扫描）' : '（点击对话框任意空白处恢复到扫码状态）'}}</span>
    </div>
    <pt-form-item label="客户样本编号：" :labelWidth="labelWidth" >
      <el-input :disabled="true" placeholder="请扫码获取" v-model="codeForm.sampleId"></el-input>
    </pt-form-item>
    <!-- <pt-form-item label="采样盒ID：" :labelWidth="labelWidth" :required="true">
      <el-input :disabled="true" placeholder="请扫码获取" v-model="form.agentProductCode" data-vv-as="产品编号" v-validate="'required'"></el-input>
    </pt-form-item> -->
    <pt-form-item label="手动填写：" :labelWidth="labelWidth">
      <el-input placeholder="扫码失败或信息不正确时使用" v-model="searchValue" :class="['input-with-select',$style['search-input']]" :clearable="true" @mousedown.stop.native @click.stop.native @keydown.enter.native="getCode(searchValue,false)">
          <el-button slot="append" :icon="icon" @click="getCode(searchValue,false)"></el-button>
      </el-input>
    </pt-form-item>
    <div :class="$style.dashed"/>
    <input type="text" class="scan-input" v-focus @focus="enabledScan" @blur="disabledScan" v-model="scanValue" @keydown.enter="getCode(scanValue)" style="width:0;height:0;border:none;"/>
		<div class="outbound-table">
				<div class="table-title">
					<span>本次出库数量:</span>
					<span style="display:inline-block;color:#edbe81;margin:0 0 10px 10px;font-weight:900;">{{this.codes.length}}</span>
				</div>
				<el-table :data="codes" stripe style="width: 100%" >
					<el-table-column prop="sampleId" label="客户样本编号">
					</el-table-column>
					<!-- <el-table-column prop="agentSampleId" label="采样盒ID">
					</el-table-column> -->
					<el-table-column prop="sampleType.name" label="样本类型">
					</el-table-column>
					<!-- <el-table-column prop="boxType.name" label="盒子类型">
					</el-table-column> -->
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button
								@click.native.prevent="deleteRow(scope.$index, codes)" type="text"
								size="small">移除</el-button>
						</template>
					</el-table-column>
				</el-table>
		</div>
    <pt-form-item label="出库原因：" :labelWidth="labelWidth" :required="true">
      <el-radio-group v-model="ruleForm.operation" @mousedown.stop.native @click.stop.native data-vv-as="出库原因" v-validate="'required'">
        <el-radio label="DELIVERY">发货</el-radio>
        <el-radio label="GOODS_DAMAGED_REMOVE_OUT">损坏</el-radio>
        <el-radio label="GOODS_EXPIRED_REMOVE_OUT">过期</el-radio>
      </el-radio-group>
    </pt-form-item>
    <template v-if="ruleForm.operation==='DELIVERY'">
      <pt-form-item label="接收单位名称：" :labelWidth="labelWidth" :required="true">
        <branch-selector v-model="ruleForm.organizationClientName" data-vv-as="接收单位名称" v-validate="'required'"></branch-selector>
      </pt-form-item>
      <pt-form-item label="选择产品：" :labelWidth="labelWidth" :required="true">
        <agent-product-selector v-model="ruleForm.agentProductId" data-vv-as="选择产品" v-validate="'required'"></agent-product-selector>
      </pt-form-item>
      <pt-form-item label="快递单号：" :labelWidth="labelWidth" :required="true">
        <div v-for="(item,i) in ruleForm.courierNumber" :key="i">
            <el-input placeholder="请输入快递单号" v-model="item.value" @mousedown.stop.native @click.stop.native :class="'courier_'+i"></el-input>
            <el-button type="text" @click="deleteItem(i)" style="margin-left:10px">删除</el-button><br>
            <el-button type="text" @click="addItem(i)" v-show="i==ruleForm.courierNumber.length-1">添加一条</el-button>
        </div>
      </pt-form-item>
    </template>
    <pt-form-item label="备注：" :labelWidth="labelWidth">
      <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="ruleForm.outputNote" @mousedown.stop.native @click.stop.native></el-input>
    </pt-form-item>
  </div>
</template>

<script>
// 组件class前缀
import agentProductSelector from './agent-product-selector'
import branchSelector from './branch-selector'
import formMixins from 'mixins/form'
const prefixCls = 'pt-adult-out-stock'
export default {
  name: 'pt-adult-out-stock',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    icon () {
      return this.iconLoading ? 'el-icon-loading' : 'el-icon-search'
    }
  },
  components: { agentProductSelector, branchSelector },
  data () {
    return {
      compName: 'scan',
      iconLoading: false,
      labelWidth: '130px',
      loading: false,
      codeForm: {
        sampleId: '',
        agentId: ''
      },
      codes: [],
      ruleForm: {
        agentProductId: '',
        operation: 'DELIVERY',
        courierNumber: [{ value: '' }]
      },
      isCanScan: false,
      scanValue: '',
      searchValue: '',
      currentBox: {}
    }
  },
  methods: {
    addItem (index) {
      if (this.ruleForm.courierNumber[index].value === '') {
        this.$message.error('请填写！')
        return
      }
      this.ruleForm.courierNumber.push({ value: '' })
      this.$nextTick(() => {
        document.querySelector('.courier_' + (index + 1) + '>input').focus()
      })
    },
    deleteItem (index) {
      if (index === 0 && this.ruleForm.courierNumber.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ruleForm.courierNumber.splice(index, 1)
      })
    },
    handleIconClick (ev) {
      console.log(ev)
      this.getCode(this.searchValue)
    },
    enabledScan () {
      this.isCanScan = true
    },
    disabledScan () {
      if (this.mouseDown) {
        return
      }
      this.isCanScan = false
    },
    async getCode (key, isScan = true) {
      console.log('key')
      if (!key) {
        this.$message.warning('没有扫描到条码')
        return
      }
      if (!isScan) {
        this.iconLoading = true
      }
      try {
        let data = await this.$store.dispatch('AdultStockFindDetailBySampleId', key)
        console.log('res-----', data)
        if (!isScan) {
          this.iconLoading = false
        }
        if (data.length) {
          this.codeForm.sampleId = key
          this.codeForm.agentId = data[0].agentSampleId
          this.currentBox = data[0]
          let sampleIdsSet = new Set(this.codes.map(item => item.sampleId))
          if (!sampleIdsSet.has(this.codeForm.sampleId)) {
            // let obj = {}
            // obj.sampleId = this.codeForm.sampleId
            // obj.id = res.data[0].id
            this.codes.push(data[0])
          } else {
            this.$message.warning('该盒子已经在列表里了')
          }
        } else {
          this.$message.error('没有获取到该盒子对应的信息')
        }

        this.scanValue = ''
      } catch (error) {
        console.log(error)
      }
    },
    deleteRow (index, rows) {
      const h = this.$createElement
      console.log('------------rows[index]', rows[index])
      this.$msgbox({
        title: '确认删除该条数据',
        message: h('p', null, [
          h('span', null, '客户样本编号: '),
          h('span', null, rows[index].sampleId),
          h('br', null, ''),
          h('span', null, '样本类型: '),
          h('span', null, rows[index].sampleType.name)
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            rows.splice(index, 1)
            done()
            instance.confirmButtonLoading = false
          } else {
            done()
          }
        }
      }).then(action => {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
      })
    },
    validateAll () {
      return Promise.all([this.validate()]).then(([, formValue]) => {
        return formValue
      })
    },
    scanSubmit () {
      console.log(this.codes)
      if (!this.codes.length) {
        this.$message.error('出库的数量为0，请进行扫码出库')
        return
      }
      let courierNums = this.ruleForm.courierNumber.filter(item => {
        return item.value !== ''
      })
      let courierNumber = courierNums.map(item => item.value)
      if (!courierNumber.length) {
        this.$message.error('请填写快递单号')
        return
      }
      this.validateAll().then(async _ => {
        this.loading = true
        let data = {
          content: this.codes.map(e => e.id),
          operation: this.ruleForm.operation,
          courierNumber: courierNumber,
          agentProductId: this.ruleForm.agentProductId,
          clientName: this.ruleForm.clientName,
          organizationClientName: this.ruleForm.organizationClientName,
          outputNote: this.ruleForm.outputNote
        }
        console.log(data)
        this.$store.dispatch('outbound', data).then(res => {
          this.$message.success('成功出库!')
          this.loading = false
          this.resetForm()
        }).catch(err => {
          console.error(err)
          this.loading = false
          this.$message.error('出库失败！' + err)
        })
      })
    },
    cancel () {
      history.go(-1)
    },
    resetForm () {
      this.codeForm = {}
      this.ruleForm = {
        agentProductId: '',
        operation: 'DELIVERY',
        courierNumber: [{ value: '' }]
      }
      this.ruleForm.clientName = ''
      this.ruleForm.courierNumber = [{ value: '' }]
      this.codes = []
      this.currentBox = {}
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.scan-adult-out-stock{
  :global{
      .el-input,.el-input__inner{
        max-width: 2.8rem;
      }
      .el-input--suffix .el-input__inner{
        min-width: 2.8rem;
      }
      .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width:117px;
        height: 155px;
      }
      el-textarea,.el-textarea__inner{
        width:500px;
      }
      .wt-upload-file{
        line-height: 0;
        margin-top: 10px;
      }
      .scan-tip{
        font-size:18px;
        padding:20px 0;
      }
      .outbound-table{
        .table-title{
          font-size:18px;
        }
        padding:0 20px;
      }
  }
  .dashed{
    margin:30px 0;
    height: 1px;
    background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
}
</style>
